// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"79e5a5bb","239":"f313afff","389":"3c7d21f4","455":"72249adb","956":"9b62e5cb","977":"5f3094e4"}[chunkId] + ".chunk.js";
};